import { render, staticRenderFns } from "./ReportChartsDoughnut.vue?vue&type=template&id=3bea8b3c&scoped=true"
import script from "./ReportChartsDoughnut.vue?vue&type=script&lang=js"
export * from "./ReportChartsDoughnut.vue?vue&type=script&lang=js"
import style0 from "./ReportChartsDoughnut.vue?vue&type=style&index=0&id=3bea8b3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bea8b3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VRow})
